import { d as b, e as z, k as d, m as F } from "./index-f8317a8e.js";
var k;
(function(a) {
  a.Component = "component", a.Api = "api", a.Auth = "auth";
})(k || (k = {}));
var A;
(function(a) {
  a.endtime_not_in_future = "endtime_not_in_future", a.no_booking_info = "no_booking_info", a.no_timeslot_selected = "no_timeslot_selected", a.no_timezone_selected = "no_timezone_selected", a.no_booking_id = "no_booking_id", a.invalid_start_time = "invalid_start_time", a.invalid_end_time = "invalid_end_time", a.invalid_timezone = "invalid_timezone";
})(A || (A = {}));
var L;
(function(a) {
  a.invalid_session = "invalid_session", a.general_error = "general_error", a.internal_error = "internal_error", a.invalid_request_error = "invalid_request_error", a.timeslot_not_available = "timeslot_not_available", a.provider_error = "provider_error", a.not_found_error = "not_found_error";
})(L || (L = {}));
class R {
  constructor() {
    this.component = (e) => {
      const t = k.Component, s = `${e} Error`;
      return {
        endtime_not_in_future: (i = '"endtime" can not be in the future') => ({
          title: s,
          message: i,
          category: t
        }),
        no_booking_info: (i = "No booking info provided") => ({
          title: s,
          message: i,
          category: t
        }),
        no_timeslot_selected: (i = "No timeslot selected") => ({
          title: s,
          message: i,
          category: t
        }),
        no_timezone_selected: (i = "No timezone selected") => ({
          title: s,
          message: i,
          category: t
        }),
        no_booking_id: (i = "No booking id provided") => ({
          title: s,
          message: i,
          category: t
        }),
        invalid_start_time: (i = "Invalid start time") => ({
          title: s,
          message: i,
          category: t
        }),
        invalid_end_time: (i = "Invalid end time") => ({
          title: s,
          message: i,
          category: t
        }),
        invalid_timezone: (i = "Invalid timezone") => ({
          title: s,
          message: i,
          category: t
        })
      };
    }, this.api = (e) => {
      const t = k.Api, s = `${e} Error`;
      return {
        invalid_session: (i) => ({
          title: s,
          message: i,
          category: t
        }),
        general_error: (i) => ({
          title: s,
          message: i,
          category: t
        }),
        internal_error: (i) => ({
          title: s,
          message: i,
          category: t
        }),
        invalid_request_error: (i) => ({
          title: s,
          message: i,
          category: t
        }),
        timeslot_not_available: (i) => ({
          title: s,
          message: i,
          category: t
        }),
        provider_error: (i) => ({
          title: s,
          message: i,
          category: t
        }),
        not_found_error: (i) => ({
          title: s,
          message: i,
          category: t
        })
      };
    };
  }
}
class C {
  constructor({ schedulerAPIURL: e, schedulerStore: t, sessionId: s, configId: i }) {
    this.errors = new R(), this.schedulerStore = t, this.schedulerAPIURL = e, this.sessionId = s, this.configId = i;
  }
  getHeaders() {
    return this.sessionId ? {
      Authorization: `Bearer ${this.sessionId}`
    } : {};
  }
  async makeAPIRequest(e, t, s, i = {}) {
    try {
      const r = new URL(this.schedulerAPIURL);
      return r.pathname = e, await (await fetch(decodeURIComponent(r.toString()), {
        method: t,
        headers: {
          "Content-Type": "application/json",
          Origin: window.location.origin,
          ...i
        },
        body: s
      })).json();
    } catch (r) {
      return {
        error: {
          message: r.message,
          title: "API request failed",
          type: "api"
        }
      };
    }
  }
  getErrorMessage(e) {
    var s, i, r, n;
    let t = (e == null ? void 0 : e.message) || (e == null ? void 0 : e.title) || "Something went wrong";
    return (e == null ? void 0 : e.type) === "provider_error" && (t = ((i = (s = e == null ? void 0 : e.provider_error) == null ? void 0 : s.error) == null ? void 0 : i.message) || ((n = (r = e == null ? void 0 : e.provider_error) == null ? void 0 : r.error) == null ? void 0 : n.title) || "Something went wrong"), t;
  }
  setConfigId(e) {
    this.configId = e;
  }
  selectDate(e) {
    this.schedulerStore.set("selectedDate", e), this.schedulerStore.set("selectedTimeslot", null);
  }
  selectTime(e) {
    this.schedulerStore.set("selectedTimeslot", e);
  }
  selectTimezone(e) {
    this.schedulerStore.set("selectedTimezone", e);
  }
  selectLanguage(e) {
    this.schedulerStore.set("selectedLanguage", e), d.changeLanguage(e);
  }
  async toggleAdditionalData(e) {
    e || await this.refetchAvailability(), this.schedulerStore.set("showBookingForm", e);
  }
  setParticipantName(e) {
    const { bookingInfo: t } = this.schedulerStore.state;
    this.schedulerStore.set("bookingInfo", {
      ...t,
      primaryParticipant: {
        ...t == null ? void 0 : t.primaryParticipant,
        name: e
      }
    });
  }
  setParticipantEmail(e) {
    const { bookingInfo: t } = this.schedulerStore.state;
    this.schedulerStore.set("bookingInfo", {
      ...t,
      primaryParticipant: {
        ...t == null ? void 0 : t.primaryParticipant,
        email: e
      }
    });
  }
  async refetchAvailability() {
    const e = /* @__PURE__ */ new Date(), t = new Date(e.getFullYear(), e.getMonth(), 1).getTime() / 1e3, s = t < e.getTime() / 1e3 ? Math.floor(e.getTime() / 1e3) : t, i = new Date(e.getFullYear(), e.getMonth() + 1, 1).getTime() / 1e3;
    return await this.getAvailability(s, i);
  }
  async resetStoreStateAndFetchAvailability() {
    const e = /* @__PURE__ */ new Date(), t = await this.refetchAvailability(), s = this.schedulerStore.get("availability").find((r) => new Date(r.start_time) > /* @__PURE__ */ new Date());
    let i = e;
    return s && (i = s.start_time), this.schedulerStore.set("selectedDate", i), this.schedulerStore.set("eventInfo", null), this.schedulerStore.set("showBookingForm", !1), this.schedulerStore.set("selectedTimeslot", null), t;
  }
  async setReschedule(e) {
    this.schedulerStore.set("isLoading", !0);
    const t = this.schedulerStore.state.eventInfo;
    return t && this.schedulerStore.set("reschedulingEventInfo", t), this.schedulerStore.set("rescheduleBookingId", e), await this.resetStoreStateAndFetchAvailability().finally(() => {
      this.schedulerStore.set("isLoading", !1);
    });
  }
  async setCancel(e) {
    this.schedulerStore.set("cancelBookingId", e);
  }
  async resetCancel() {
    const e = await this.resetStoreStateAndFetchAvailability();
    return this.schedulerStore.set("cancelBookingId", ""), this.schedulerStore.set("cancelledEventInfo", null), e;
  }
  async bookTimeslot(e) {
    var m;
    this.schedulerStore.set("isLoading", !0);
    const { selectedTimeslot: t, selectedTimezone: s, bookingInfo: i } = this.schedulerStore.state;
    if (!e && !i)
      return { error: this.errors.component(d.t("createBookingErrorTitle")).no_booking_info() };
    const r = (e == null ? void 0 : e.timeslot) || t;
    if (!r)
      return { error: this.errors.component(d.t("createBookingErrorTitle")).no_timeslot_selected() };
    const n = e && (e != null && e.timezone) ? e == null ? void 0 : e.timezone : s;
    if (!n)
      return { error: this.errors.component(d.t("createBookingErrorTitle")).no_timezone_selected() };
    const o = this.schedulerStore.get("availabilityOrderEmails");
    let u = "";
    if (o.length > 0) {
      const g = r.emails;
      for (let c = 0; c < o.length; c++)
        if (g.includes(o[c])) {
          u = o[c];
          break;
        }
    }
    const _ = e ? e == null ? void 0 : e.primaryParticipant : i == null ? void 0 : i.primaryParticipant, h = e ? (e == null ? void 0 : e.guests) || [] : (i == null ? void 0 : i.guests) || [], y = e ? e == null ? void 0 : e.additionalFields : i == null ? void 0 : i.additionalFields, I = this.getHeaders(), S = `/v3/scheduling/bookings${!this.sessionId && this.configId ? `?configuration_id=${this.configId}` : ""}`, l = await this.makeAPIRequest(decodeURIComponent(S), "POST", JSON.stringify({
      participants: u ? [{ email: u }] : void 0,
      additional_fields: y,
      additional_guests: h,
      guest: { ..._ },
      start_time: r.start_time.getTime() / 1e3,
      end_time: r.end_time.getTime() / 1e3,
      timezone: n
    }), I);
    if ("error" in l) {
      this.schedulerStore.set("isLoading", !1);
      const g = (m = l.error) == null ? void 0 : m.type;
      let c = l.error;
      if (g && g in this.errors.api("Create Booking")) {
        const w = this.getErrorMessage(c);
        c = this.errors.api("Create Booking")[g](w);
      }
      return { error: c };
    }
    return "data" in l && this.schedulerStore.set("eventInfo", l == null ? void 0 : l.data), this.schedulerStore.set("isLoading", !1), l;
  }
  async getUISettings() {
    var r;
    this.schedulerStore.set("isLoading", !0);
    const e = this.getHeaders(), s = `/v3/scheduling/ui-settings${!this.sessionId && this.configId ? `?configuration_id=${this.configId}` : ""}`, i = await this.makeAPIRequest(s, "GET", void 0, e);
    if ("error" in i) {
      this.schedulerStore.set("isLoading", !1);
      const n = (r = i.error) == null ? void 0 : r.type;
      let o = i.error;
      return n && n in this.errors.api(d.t("getUISettingErrorTitle")) && (o = this.errors.api(d.t("getUISettingErrorTitle"))[n]((o == null ? void 0 : o.message) || (o == null ? void 0 : o.title) || "Something went wrong")), { error: o };
    }
    return "data" in i && this.schedulerStore.set("configSettings", i.data), this.schedulerStore.set("isLoading", !1), i;
  }
  getStartTimeWithMinBookingNotice(e) {
    var i;
    const t = (i = this.schedulerStore.get("configSettings")) == null ? void 0 : i.scheduler, s = t == null ? void 0 : t.min_booking_notice;
    return s ? e + s * 60 : e;
  }
  getEndTimeForAvailableDaysInFuture(e) {
    var n, o;
    const t = /* @__PURE__ */ new Date(), s = (o = (n = this.schedulerStore.get("configSettings")) == null ? void 0 : n.scheduler) == null ? void 0 : o.available_days_in_future, i = Math.floor(F(t, s).getTime() / 1e3);
    return Math.min(i, e);
  }
  async getAvailability(e = 0, t = 0) {
    var y, I, f, S;
    this.schedulerStore.set("isLoading", !0);
    const s = new URLSearchParams(), i = /* @__PURE__ */ new Date(), r = i.getTime();
    if (t && t < r / 1e3)
      return this.schedulerStore.set("isLoading", !1), { error: this.errors.component(d.t("getAvailabilityErrorTitle")).endtime_not_in_future() };
    if (!e) {
      const l = new Date(i.getFullYear(), i.getMonth(), 1);
      e = Math.floor(l.getTime() / 1e3);
    }
    if (e = this.getStartTimeWithMinBookingNotice(e), !t) {
      const l = new Date(i.getFullYear(), i.getMonth() + 1, 0);
      t = Math.floor(l.getTime() / 1e3);
    }
    t = this.getEndTimeForAvailableDaysInFuture(t), s.append("start_time", encodeURIComponent(e.toString())), s.append("end_time", encodeURIComponent(t.toString())), this.configId && !this.sessionId && s.append("configuration_id", encodeURIComponent(this.configId));
    const n = this.schedulerStore.get("rescheduleBookingId");
    n && s.append("booking_id", encodeURIComponent(n));
    const o = s.toString(), u = `/v3/scheduling/availability${o ? `?${o}` : ""}`, _ = this.getHeaders(), h = await this.makeAPIRequest(decodeURIComponent(u), "GET", void 0, _);
    if ("error" in h) {
      this.schedulerStore.set("availability", []), this.schedulerStore.set("isLoading", !1);
      const l = (y = h.error) == null ? void 0 : y.type;
      let m = h.error;
      if (l && l in this.errors.api(d.t("getAvailabilityErrorTitle"))) {
        const g = this.getErrorMessage(m);
        m = this.errors.api(d.t("getAvailabilityErrorTitle"))[l](g);
      }
      return { error: m };
    }
    if ("data" in h) {
      const m = (((f = (I = h.data) == null ? void 0 : I.time_slots) == null ? void 0 : f.map((c) => ({
        ...c,
        start_time: new Date(c.start_time * 1e3),
        end_time: new Date(c.end_time * 1e3)
      }))) || []).filter((c) => c.start_time.getTime() > r);
      this.schedulerStore.set("availability", m);
      const g = ((S = h.data) == null ? void 0 : S.order) || [];
      this.schedulerStore.set("availabilityOrderEmails", g);
    }
    return this.schedulerStore.set("isLoading", !1), h;
  }
  async cancelBooking(e, t) {
    var o;
    if (this.schedulerStore.set("isLoading", !0), !e)
      return { error: this.errors.component(d.t("cancelBookingErrorTitle")).no_booking_id() };
    const s = !this.sessionId && this.configId ? `?configuration_id=${this.configId}` : "", i = `/v3/scheduling/bookings/${e}${s}`, r = this.getHeaders(), n = await this.makeAPIRequest(decodeURIComponent(i), "DELETE", JSON.stringify({
      action: "cancel",
      cancellation_reason: t
    }), r);
    if ("error" in n) {
      this.schedulerStore.set("isLoading", !1);
      const u = (o = n.error) == null ? void 0 : o.type;
      let _ = n.error;
      if (u && u in this.errors.api(d.t("cancelBookingErrorTitle"))) {
        const h = this.getErrorMessage(_);
        _ = this.errors.api(d.t("cancelBookingErrorTitle"))[u](h);
      }
      return { error: _ };
    }
    return this.schedulerStore.set("cancelledEventInfo", {
      booking_id: e
    }), this.schedulerStore.set("rescheduleBookingId", ""), this.schedulerStore.set("isLoading", !1), n;
  }
  async rescheduleBooking(e, t) {
    var E;
    if (this.schedulerStore.set("isLoading", !0), !e)
      return { error: this.errors.component(d.t("rescheduleBookingErrorTitle")).no_booking_id() };
    const s = this.errors.api(d.t("rescheduleBookingErrorTitle")), i = this.errors.component(d.t("rescheduleBookingErrorTitle")), { bookingInfo: r, selectedTimeslot: n, selectedTimezone: o } = this.schedulerStore.state, { startTime: u, endTime: _, timezone: h } = t, y = u || (n == null ? void 0 : n.start_time);
    if (!y)
      return { error: i.invalid_start_time('Please pass "startTime" in data or set "selectedTimeslot" in the defaultSchedulerState.') };
    const I = _ || (n == null ? void 0 : n.end_time);
    if (!I)
      return { error: i.invalid_end_time('Please pass "endTime" in data or set "selectedTimeslot" in the defaultSchedulerState.') };
    const f = this.schedulerStore.get("availabilityOrderEmails");
    let S = "";
    if (f.length > 0) {
      const T = (n == null ? void 0 : n.emails) || [];
      for (let v = 0; v < f.length; v++)
        if (T.includes(f[v])) {
          S = f[v];
          break;
        }
    }
    const l = h || o;
    if (!l)
      return { error: i.invalid_timezone('Please pass "timezone" in data or set "selectedTimezone" in the defaultSchedulerState.') };
    const m = t ? t == null ? void 0 : t.primaryParticipant : r == null ? void 0 : r.primaryParticipant, g = t ? (t == null ? void 0 : t.guests) || [] : (r == null ? void 0 : r.guests) || [], c = t ? t == null ? void 0 : t.additionalFields : r == null ? void 0 : r.additionalFields, w = !this.sessionId && this.configId ? `?configuration_id=${this.configId}` : "", B = `/v3/scheduling/bookings/${e}${w}`, P = this.getHeaders(), p = await this.makeAPIRequest(decodeURIComponent(B), "PATCH", JSON.stringify({
      start_time: y.getTime() / 1e3,
      end_time: I.getTime() / 1e3,
      time_zone: l,
      additional_fields: c,
      guest: { ...m },
      additional_guests: g,
      participants: S ? [{ email: S }] : void 0
    }), P);
    if ("error" in p) {
      this.schedulerStore.set("isLoading", !1);
      const T = (E = p.error) == null ? void 0 : E.type;
      let v = p.error;
      if (T && T in s) {
        const M = this.getErrorMessage(v);
        v = s[T](M);
      }
      return { error: v };
    }
    const D = this.schedulerStore.get("reschedulingEventInfo");
    if ("data" in p)
      this.schedulerStore.set("eventInfo", p == null ? void 0 : p.data);
    else if (D)
      this.schedulerStore.set("eventInfo", D);
    else {
      const T = {
        booking_id: e
      };
      this.schedulerStore.set("eventInfo", T);
    }
    return this.schedulerStore.set("isLoading", !1), p;
  }
}
function N(a = {}) {
  const e = {
    selectedDate: null,
    selectedLanguage: navigator.language,
    selectedTimezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
    selectedTimeslot: null,
    showBookingForm: !1,
    availabilityOrderEmails: [],
    selectableDates: null,
    availability: [],
    eventDuration: 0,
    state: "ready",
    eventInfo: null,
    cancelledEventInfo: null,
    isLoading: !1,
    nylasBranding: !0,
    ...a
  };
  b("[defaultNylasStoreState]: ", e);
  const t = z(e);
  return t.onChange("availability", (s) => {
    b("[availability]: ", s);
    const i = s.map((o) => o.start_time);
    b("[selectableDates]: ", i), t.set("selectableDates", i);
    const r = s[0];
    if (!r)
      return;
    const n = Math.floor((r.end_time.getTime() - r.start_time.getTime()) / 6e4);
    b("[durationMinutes]: ", n), t.set("eventDuration", n);
  }), t.reset = () => {
    for (const s in e) {
      const i = e[s];
      t.set(s, i);
    }
  }, t;
}
export {
  N as C,
  k as E,
  C as N
};
